export default class Services {
  
  constructor( api ) {
    this.api = api
    this.connect = api.child( 'service' )
  }

  /**
   * Creates a new Service
   * @param {object} data
   * @param {int} data.version the new version value
   * @param {string} data.alias the new alias value
   * @param {string} data.name the new name value
   * @param {string} data.description the new description value
   * @param {array<routes>} data.routes the routes
   * @param {boolean} data.replaceRoutes if true, all current routes are removed.
   * If true, the updated routes must include their id.
   */
  create( data ) {
    return this.connect.post( data )
  }

  /**
   * Lists the Services. 
   * @param {object} data
   * @param {array<string>} data.attributes the fields to include in result
   * @param {boolean} data.includeRoutes if false, routes are not included
   * 
   **/
  list( data ) {
    return this.connect.get( data )
  }

  /**
   * Removes all Services
   */
  removeAll( ) {
    return this.connect.delete( )
  }
}
